import { setBodyOverflowHidden } from '@/app/_utils/set-body-overflow'

export const closeMenuOnNavigate = () => {
    setBodyOverflowHidden(false)

    const headerCheckboxes = document.querySelectorAll(
        'header [type="checkbox"]:checked'
    ) as NodeListOf<HTMLInputElement>

    if (headerCheckboxes) {
        setTimeout(() => {
            headerCheckboxes.forEach((item) => (item.checked = false))
        }, 1000)
    }
}
